import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    events: {
        'click pre'     : 'copyCode',
        'click .revoke' : 'revoke',
        'click .create' : 'create'
    },

    dom_handlers: {
        revoke: function(e) {
            this.$el.find('button.revoke').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'widget_trigger_code/delete',
                success: function() {
                    Cache.widget_trigger_code.remove(Cache.widget_trigger_code.where({project_id: Cache.default_project_id}));
                    UI.success('Widget URL revoked successfully');
                }
            });
        },

        create: function(e) {
            e.preventDefault();

            Cache.app.request({
                action: 'widget_trigger_code/create',
                success: function(response) {
                    Cache.widget_trigger_code.add({
                        account_id: Cache.account.id,
                        project_id: Cache.default_project_id,
                        code: response
                    });

                    UI.success('Widget URL created successfully');
                }
            });
        },

        copyCode: function(e) {
            try {
                var range = document.createRange();
                range.selectNode(this.$el.find('pre b').get(0));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand('copy');
            } catch (e) {
            }

            UI.success('Widget parameter copied');
        }
    },

    initialize: function(options) {
        this.listenTo(Cache.widget_trigger_code, 'add remove reset change', this.render);
    },

    render: function() {
        var content = '';

        var widget_settings = Cache.app.isAdmin() ? '<a href="#" class="widget-settings"><b>widget settings</b></a>' : 'widget settings';

        var widget_trigger_model = Cache.widget_trigger_code.findWhere({project_id: Cache.default_project_id});

        if (widget_trigger_model) {
            var base_url = 'https://www.yoursite.com/';

            content += '<p class="text-info margin-bottom-8">Install widget code and add the query string below to your website URL to see the widget.</p>';
            content += '<pre>' + base_url + '<span class="purple"><b>?ubwc=' + widget_trigger_model.escape('code') + '</b></span>';

            content += '<div class="actions">';

            /*
            if (Cache.app.isAdmin()) {
                content += '<button class="revoke small info float-left margin-right-4">Revoke</button>';
            }*/

            content += '</div>';

            content += '</pre>';
        } else {
            content += '<div class="divider-10"></div><a href="#" class="create">+ Generate a new Widget URL</a>';
        }

        this.$el.html(content);

        return this;
    }
});